"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require("./classes/Dictionary");

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  INVESTOR_LOSS: "I understand startups and small businesses are very risky. I can afford 100% loss of all investments I make on %Offer Name%.",
  INVESTOR_WAIT_TIME: "I understand securities on %Offer Name% are not easily re-sold. There is no secondary market. I can wait years for a return.",
  INVESTOR_RISK: "I understand %Offer Name% does not offer investment advice. I have the sophistication and education to evaluate investments on my own",
  INVESTOR_CANCEL_TIME: "I understand I have up to 48 hours before the close of the campaign to cancel my investment.",
  INVESTOR_CONFIRM: "I authorize that everything in this application is true to my knowledge."
});